<div class="ev-tooltip-simple">{{ text() }}</div>
